import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export type UploadProps = SVGDefaultProps & {
  backgroundFill: string;
};

export const Upload = ({
  size = 14,
  title = 'Upload',
  fill = colors.white,
  backgroundFill = colors.kermit,
}: Partial<UploadProps>) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 28.51 27.63">
      {Boolean(title) && <title>{title}</title>}
      <path
        d="M70.61,329.12h-1a13.82,13.82,0,0,0,.08,27.64h.88a13.82,13.82,0,0,0,0-27.64Z"
        transform="translate(-55.91 -329.12)"
        fill={backgroundFill}
      />
      <path
        d="M74.49,339.93l-3.74-4.19a.72.72,0,0,0-.53-.23h0a.39.39,0,0,0-.15,0,.63.63,0,0,
          0-.4.26L66,339.93a.7.7,0,0,0,.05,1h0a.71.71,0,0,0,1-.05h0l2.5-2.8v8.54a.7.7,0,
          0,0,.7.71.71.71,0,0,0,.71-.71h0v-8.55l2.51,2.81a.73.73,0,0,0,.53.24.8.8,0,0,0,
          .47-.18.7.7,0,0,0,.06-1Z"
        transform="translate(-55.91 -329.12)"
        fill={fill}
      />
      <path
        d="M65.67,350.37h9a.72.72,0,0,0,0-1.43h-9a.72.72,0,0,0,0,1.43Z"
        transform="translate(-55.91 -329.12)"
        fill={fill}
      />
    </svg>
  );
};
